module.exports = __webpack_public_path__ + "img/GreatVisibility.51b9cb81.png";